export default __webpack_public_path__ + "static/media/UNIDOGenderEqualityAndEmpowermentOfWomen.93680a25.pdf";